import React, { Component } from 'react';
import DeletableEffectComponent from 'components/effects/DeletableEffectComponent.js';
import FilterEffect from 'components/effects/FilterEffect.js';
import LFOTrackComponent from 'components/lfo/LFOTrackComponent.js';

class ParameterModulatorsDocumentation extends Component {
    constructor(props) {
        super(props);

        if (this.filterEffect) {
            this.filterEffect.enable();
        }
    }

    get track() {
        return this.props.sequencerEngine.tracks[0];
    }

    get filterEffect() {
        if (this.track) {
            return this.track.effectsChains[0].effects[1];
        }

        return undefined;
    }

    componentDidMount() {
        // want to enable the filter effect and show that
        if (this.filterEffect) {
            this.filterEffect.enable();
        }
    }

    get effectComponent() {
        if (this.filterEffect === undefined) {
            return (<div></div>);
        }
        
        return (
            <div className="demo-effect-container">
                  <DeletableEffectComponent
                    onDeleteEffect={() => []}
                    effectNumber={1}
                    onToggle={() => []}
                    track={this.track}
                    group={undefined}
                    sequencerEngine={this.props.sequencerEngine}
                    send={undefined}
                    effect={this.filterEffect}
                    automation={undefined}>
                    <FilterEffect
                      effectNumber={1}
                      sequencerEngine={this.props.sequencerEngine}
                      automation={undefined}
                      selectedParameter={undefined}
                      onEffectsChange={() => []}
                      onParameterChanged={() => []}
                      filterEffect={this.filterEffect}/>
                  </DeletableEffectComponent>
                </div>
        );
    }


    componentWillUnmount() {
        if (this.filterEffect) {
            this.filterEffect.enable(false);
        }
    }

    render() {
        return (
            <div>
              <p>
                Effects with static settings can get pretty boring fast. That's why
                every parameter in Zequencer can be set to a <b>modulator</b>.
              </p>
              <p>
                A <b>modulator</b> is a signal that changes from one state to another, in
                a controlled manner. When you connect a <b>modulator</b> to a parameter, that
                parameter's value will be controlled by the <b>modulator</b>.
              </p>
              <p>
                There are 2 types of modulators: LFOs and Envelopes. 
              </p>
              <p>
                Each sub-sequence has 4 dedicated LFOs and 4 dedicated Envelopes.
                They are shown at the top of the sequencer view.
                <LFOTrackComponent
                  sequencerEngine={this.props.sequencerEngine}
                  envelopesTrack={this.props.sequencerEngine.envelopesTrack}
                  lfosTrack={this.props.sequencerEngine.lfosTrack}/>
              </p>
              <p>
                To connect a parameter to a modulator, click on the parameter name.
                This will bring up 4 square icons (LFOs) followed by 4 circle icons (Envelopes),
                each with their own color (corresponding to each modulator option).
              </p>
              <p>
                Click one of the modulator icons to connect the parameter to that modulator.
                {this.effectComponent}
             </p>
              <p className="sub-header">
                LFO
              </p>
              <p>
                An LFO cycles between a minimum and maximum value at a given rate,
                following a waveform. The rate can be set using rate dropdown.
                You can set the rate to be unsynced by unchecking the “Synced” checkbox. 
              </p>
              <p>
                Example: Take a filter effect, and set the cutoff frequency to be
                modulated by LFO 1. Once connected, change the minimum and maximum
                values of LFO 1 and notice the change. Then change the rate.
              </p>
              <p className="sub-header">
                Envelope 
              </p>
              <p>
                An envelope can be set to be triggered by a specific track.
                The dropdown at the top right of the envelope box selects which
                track triggers the envelope. Once set, every time a track triggers,
                the envelope will be triggered. 
              </p>
              <p>
                There are 2 options for when to trigger an envelope. 
                <ul>
                  <li>
                    <b>Pre-FX</b> will trigger the envelope before any midi-effects
                    are applied. So if you have an Arpeggiator as a midi effect,
                    and have Pre-FX set, it will only trigger the envelope when
                    the original trigger is hit, instead of triggering for every arpeggiator hit.
                  </li>
                  <li>
                    <b>Post-FX</b> will trigger the envelope after all midi-effects
                    have been applied. So if you have an Arpeggiator, it will
                    trigger every time the arpeggiator hits.
                  </li>
                </ul>
              </p>
              <p>
                An envelope has 4 well-known parameters:
                <ul>
                  <li>
                    <b>Attack</b>: How long it takes for the envelope to go from the
                    min-value of the parameter’s modulation to the max-value.
                  </li>
                  <li>
                    <b>Decay</b>: How long it takes for the envelope to go from the
                    max value of that parameter’s modulation to the sustain-value.
                  </li>
                  <li>
                    <b>Sustain</b>: Controls what value the parameter should remain
                    at, after the attack and decay stages of the envelope have
                    completed. The value is determined in relation to the min and max of the parameter.
                  </li>
                  <li>
                    <b>Release</b>: Controls how long it takes for the parameter
                    value to return to its original value once the trigger is released.
                  </li>
                </ul>
              </p>
              <p className="sub-header">
                Parameter Min/Max
              </p>
              <p>
                Once a parameter is connected to a modulator, you may want to
                define the min and max values for the  modulation.
              </p>
              <p>
                For example, if you set the filter cutoff frequency to be controlled by an LFO,
                you may want to define what the min and max frequencies are. You
                can do this by going to the <b>Mods</b> view of an effect. You can access
                the <b>Mods</b> view by clicking the <b>Mods</b> button at the top right of an effect,
                next to the delete button.
              </p>
              <p>
                Note that a parameter needs to be connected to a modulator in order to appear here.
                {this.effectComponent}
              </p>
            </div>
        );
    }
}

export default ParameterModulatorsDocumentation;
